import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Carovnik iz Oza",
  "description": "",
  "published": "2007-03-28T00:00:00.000Z",
  "redirect_from": ["/blog/carovnik-iz-oza/swizec/250"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Velikokrat gledam filme ne zaradi zasedbe, posebnih efektov ali celo zgodbe, ampak zaradi njihovega zvena. Ne vem, sicer, kaj je na zvoku v filmih in videu, da me tako mocno privlaci, ampak me. Torej predstavljajte si moje presenecenje, ko sem vceraj ponesreci preklopil na TCM in zagledal `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/The_Wizard_of_Oz_(1939_film)"
      }}>{`enega najbolje zvenecih filmov vseh casov`}</a>{`. Ze cel dan si sam pri sebi pojem pesmi iz njega!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      